<template>
  <div id="layoutController">
    <!-- <v-tooltip left color="#1d2021">
      <template v-slot:activator="{ on, attrs }">
        <div class="menu-controller" @click.stop="drawer = !drawer" v-show="!drawer" v-bind="attrs" v-on="on">
          <div class="icon-controller">
            <div class="icon-controller-sub"></div>
          </div>
        </div>
      </template>
      <span>Record Setting</span>
    </v-tooltip> -->
    <!-- <v-navigation-drawer v-model="drawer"> -->
    <v-container>
      <v-container class="layoutBtn">
        <p>Layout</p>
        <v-btn-toggle v-model="faceVideoData.toggle_layout" background-color="transparent" borderless mandatory>
          <v-btn elevation="0" class="btn basic" type="button" @click="setLayoutType('corner')">
            <div class="btn-display">
              <div class="btn-faceVideo"></div>
            </div>
          </v-btn>
          <v-btn elevation="0" class="btn overlap" type="button" @click="setLayoutType('overlap')">
            <div class="btn-display">
              <div class="btn-faceVideo"></div>
            </div>
          </v-btn>
          <v-btn elevation="0" class="btn column" type="button" @click="setLayoutType('separated')">
            <div class="btn-display">
              <div class="btn-faceVideo"></div>
            </div>
          </v-btn>
        </v-btn-toggle>
      </v-container>

      <v-container class="faceVideoPositionBtn">
        <p>Position</p>
        <v-radio-group
          v-if="faceVideoData.layoutType != 'separated'"
          v-model="faceVideoData.radios1"
          class="faceVideoPositionRadio"
          row
          dense
          mandatory
        >
          <v-radio class="radio" label="" value="radio-1" @click="topLeft"></v-radio>
          <v-radio class="radio" label="" value="radio-2" @click="topRight"></v-radio>
          <v-radio class="radio" label="" value="radio-3" @click="bottomLeft"></v-radio>
          <v-radio class="radio" label="" value="radio-4" @click="bottomRight"></v-radio>
        </v-radio-group>

        <v-btn-toggle
          v-if="faceVideoData.layoutType == 'separated'"
          class="container-separated"
          v-model="faceVideoData.toggle_separated"
          background-color="transparent"
          mandatory
        >
          <v-btn class="btn-separated" @click="setSeparatedAlign('left')" elevation="0" plain>
            <div class="icon-separated-left"><div class="icon-separated-left-sub"></div></div>
          </v-btn>
          <v-btn class="btn-separated" @click="setSeparatedAlign('right')" elevation="0" plain>
            <div class="icon-separated-right"><div class="icon-separated-right-sub"></div></div>
          </v-btn>
        </v-btn-toggle>
      </v-container>

      <v-container class="faceVideoShapeBtn">
        <p :style="faceVideoData.layoutType == 'separated' ? 'opacity: 0.3' : 'opacity: 1'">Shape</p>
        <v-btn-toggle v-model="faceVideoData.toggle_shape" background-color="transparent" borderless mandatory>
          <v-btn
            elevation="0"
            class="btn round"
            type="button"
            @click="round($event)"
            :disabled="faceVideoData.layoutType == 'separated'"
          >
            <div class="btn-display">
              <div class="btn-faceVideo"></div>
            </div>
          </v-btn>
          <v-btn
            elevation="0"
            class="btn square"
            type="button"
            @click="square($event)"
            :disabled="faceVideoData.layoutType == 'separated'"
          >
            <div class="btn-display">
              <div class="btn-faceVideo"></div>
            </div>
          </v-btn>
        </v-btn-toggle>
      </v-container>

      <v-container class="faceVideoSizeBtn">
        <p :style="faceVideoData.layoutType == 'separated' ? 'opacity: 0.3' : 'opacity: 1'">Size</p>
        <v-btn-toggle v-model="faceVideoData.toggle_size" background-color="transparent" borderless mandatory>
          <v-btn
            elevation="0"
            class="btn small"
            type="button"
            @click="setSize('small')"
            :disabled="faceVideoData.layoutType == 'separated'"
          >
            <div class="btn-display">
              <div class="btn-faceVideo"></div>
            </div>
          </v-btn>
          <v-btn
            elevation="0"
            class="btn medium"
            type="button"
            @click="setSize('medium')"
            :disabled="faceVideoData.layoutType == 'separated'"
          >
            <div class="btn-display">
              <div class="btn-faceVideo"></div>
            </div>
          </v-btn>
          <v-btn
            elevation="0"
            class="btn large"
            type="button"
            @click="setSize('large')"
            :disabled="faceVideoData.layoutType == 'separated'"
          >
            <div class="btn-display">
              <div class="btn-faceVideo"></div>
            </div>
          </v-btn>
        </v-btn-toggle>
      </v-container>

      <v-container class="backgroundColorBtn">
        <p :style="faceVideoData.layoutType == 'corner' ? 'opacity: 0.3' : 'opacity: 1'">Background Color</p>
        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" offset-x absolute z-index="203 !important">
          <template v-slot:activator="{ on: menu }" :childData="faceVideoData">
            <v-btn
              :disabled="faceVideoData.layoutType == 'corner'"
              elevation="0"
              class="btn btn-pallette"
              type="button"
              v-on="{ ...menu }"
              dark
            >
              <v-icon large color="white" class="ma-1">mdi-palette</v-icon>
            </v-btn>
          </template>

          <v-tabs v-model="tab" background-color="transparent" grow dark>
            <v-tab @click="faceVideoData.isUseGradient = true">Gradient</v-tab>
            <v-tab @click="faceVideoData.isUseGradient = false">Color</v-tab>
          </v-tabs>

          <v-tabs-items style="background-color: #21343b" v-model="tab">
            <v-tab-item>
              <div class="container-gradient">
                <div class="button-group">
                  <v-color-picker
                    v-model="faceVideoData.gradient.start"
                    canvas-height="100"
                    width="270"
                    mode="hexa"
                    show-swatches
                    flat
                    :swatches="swatches2"
                    class="container-swatches mx-4"
                  ></v-color-picker>
                  <v-divider dark></v-divider>
                  <v-color-picker
                    v-model="faceVideoData.gradient.end"
                    canvas-height="100"
                    width="270"
                    mode="hexa"
                    show-swatches
                    flat
                    :swatches="swatches2"
                    class="container-swatches mx-4"
                  ></v-color-picker>
                  <!-- <v-btn @click="gradient($event)">Gradient Generate</v-btn> -->
                </div>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="color-container">
                <v-color-picker
                  v-model="faceVideoData.bgColor"
                  hide-canvas
                  hide-mode-switch
                  hide-sliders
                  mode="rgba"
                  show-swatches
                  swatches-max-height="200"
                  :swatches="swatches"
                  class="container-swatches"
                ></v-color-picker>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-menu>
      </v-container>
    </v-container>
    <!-- </v-navigation-drawer> -->
  </div>
</template>

<script>
export default {
  name: 'LayoutController',
  props: {},
  data() {
    return {
      tab: null,
      items: ['Gradient', 'Color'],
      drawer: true,
      menu: false,
      colorPicker: '',
      swatches: [
        ['#FF575F', '#dddddd'],
        ['#FFC542', '#96A7AF'],
        ['#3DD598', '#475E69'],
        ['#0062FF', '#30444E'],
        ['#755FE2', '#1a272e'],
      ],
      swatches2: [['#FF575F'], ['#FFC542'], ['#3DD598'], ['#0062FF'], ['#755FE2']],
      colors: [
        { id: 0, hex: '#f12711', disabled: false },
        { id: 1, hex: '#f5af19', disabled: false },
      ],
      layoutVariable: {
        separatedMargin: `24px`,
      },
    }
  },
  methods: {
    topLeft() {
      this.faceVideoData.position = { top: 0, left: 0, right: 'unset', bottom: 'unset' }
      this.faceVideoData.margin = { top: this.faceMargin.y, left: this.faceMargin.x, right: 0, bottom: 0 }
    },
    topRight() {
      this.faceVideoData.position = { top: 0, left: 'unset', right: 0, bottom: 'unset' }
      this.faceVideoData.margin = { top: this.faceMargin.y, left: 0, right: this.faceMargin.x, bottom: 0 }
    },
    bottomLeft() {
      this.faceVideoData.position = { top: 'unset', left: 0, right: 'unset', bottom: 0 }
      this.faceVideoData.margin = { top: 0, left: this.faceMargin.x, right: 0, bottom: this.faceMargin.y }
    },
    bottomRight() {
      this.faceVideoData.position = { top: 'unset', left: 'unset', right: 0, bottom: 0 }
      this.faceVideoData.margin = { top: 0, left: 0, right: this.faceMargin.x, bottom: this.faceMargin.y }
    },
    square(e) {
      e.stopPropagation()
      this.faceVideoData.shape = 'square'
    },
    round(e) {
      e.stopPropagation()
      this.faceVideoData.shape = 'round'
    },
    setSize(value) {
      this.faceVideoData.size = value
      this.resizeFaceVideo()
    },
    setLayoutType(value) {
      if (this.faceVideoData.layoutType !== value) {
        this.faceVideoData.layoutType = value
        if (this.faceVideoData.layoutType === 'separated')
          this.setSeparatedAlign(this.faceVideoData.separatedAlign ? this.faceVideoData.separatedAlign : 'left')
        else this.resizeFaceVideo()
        this.$store.dispatch('setIsLayoutChanged', !this.$store.getters.isLayoutChanged)
      }
    },
    resizeFaceVideo() {
      switch (this.faceVideoData.radios1) {
        case 'radio-1':
          this.topLeft()
          break
        case 'radio-2':
          this.topRight()
          break
        case 'radio-3':
          this.bottomLeft()
          break
        case 'radio-4':
          this.bottomRight()
          break
        default:
          break
      }
    },
    setSeparatedAlign(value) {
      this.faceVideoData.separatedAlign = value
      if (value === 'right')
        this.faceVideoData.margin = { top: 0, left: this.layoutVariable.separatedMargin, right: 0, bottom: 0 }
      else this.faceVideoData.margin = { top: 0, left: 0, right: this.layoutVariable.separatedMargin, bottom: 0 }
    },
    //TODO ScreenAndMediaRecorder와 공통임으로 유틸로 넣기
    vw(v) {
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      return (v * w) / 100
    },
    pixelToVw(pixel) {
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      return (pixel * 100) / w
    },
  },
  computed: {
    faceVideoData() {
      return this.$store.getters.faceVideoData
    },
    bgColor() {
      return this.faceVideoData.bgColor
    },
    gradient() {
      return this.faceVideoData.gradient
    },
    faceMargin() {
      let margin = { x: '1vw', y: '1vw' }
      if (this.faceVideoData.layoutType === 'overlap') {
        switch (this.faceVideoData.size) {
          case 'small':
            margin = { x: '1vw', y: '1vw' }
            break
          case 'medium':
            margin = { x: '0.8vw', y: '0.8vw' }
            break
          case 'large':
            margin = { x: '0.5vw', y: '0.5vw' }
            break

          default:
            break
        }
      }
      return margin
    },
  },
  watch: {
    group() {
      this.drawer = false
    },
    bgColor() {
      this.faceVideoData.isUseGradient = false
    },
    gradient: {
      deep: true,
      immediate: true,
      handler() {
        this.faceVideoData.isUseGradient = true
      },
    },
  },
}
</script>

<style scoped>
#layoutController >>> .v-navigation-drawer__content {
  /* background-color: transparent; */
}
.container .btn {
  position: relative;
  width: 45px;
  height: 45px;
  background-color: transparent;
  margin: 0 10px 0 0 !important;
  padding: 0 !important;
  min-width: 0 !important;
}
.container .btn:last-child {
  margin: 0 !important;
}
.v-btn-toggle > .v-btn.v-btn {
  opacity: 0.4;
}
.v-btn-toggle > .v-btn--active {
  opacity: 1 !important;
}
.v-btn-toggle >>> .v-btn--disabled {
  opacity: 0.1 !important;
}
.v-btn:before {
  opacity: 1;
  background-color: transparent;
}
.container p {
  font-size: 13px;
  color: #96a7af;
  font-weight: 500;
  margin-bottom: 10px;
}
.v-tooltip__content {
  font-size: 12px !important;
  opacity: 1;
}
/* Position button (not separated) */
.faceVideoPositionRadio {
  position: relative;
  width: 102px;
  height: 67px;
  padding: 0 5px;
  background-color: #536a6e;
  border-radius: 10px;
}
.faceVideoPositionBtn .radio {
  position: relative;
  margin: 4px 0;
}
.faceVideoPositionBtn .radio:nth-child(1),
.faceVideoPositionBtn .radio:nth-child(3) {
  margin-right: 41px;
}
.faceVideoPositionBtn >>> .mdi-radiobox-blank {
  background-color: #fff;
  border-radius: 50%;
  width: 4px !important;
  height: 4px !important;
  margin-top: 12px;
  margin-left: 12px;
  transition: none !important;
}
.faceVideoPositionBtn >>> .mdi-radiobox-blank::before {
  border-radius: 50%;
  width: 10px !important;
  height: 10px !important;
  content: '';
}
.faceVideoPositionBtn >>> .v-input--selection-controls__ripple:before {
  width: 20px;
  height: 20px;
  top: 6px;
  left: 6px;
  margin: 0;
  padding: 0;
  background-color: #ccc;
  opacity: 0.6;
  border-radius: 5px;
  border: none;
}
.faceVideoPositionBtn >>> .mdi-radiobox-marked {
  position: relative;
  z-index: 1;
  cursor: default;
  transition: none !important;
}
.faceVideoPositionBtn >>> .mdi-radiobox-marked::before {
  position: relative;
  top: 2px;
  left: 2px;
  background-color: white;
  border-radius: 5px;
  width: 20px !important;
  height: 20px !important;
  content: '';
}
.faceVideoPositionBtn >>> .v-input--selection-controls__input {
  margin: 0 !important;
}
/* Position button (separated) */
#layoutController >>> .container .btn-separated {
  position: relative;
  width: 72px;
  height: 62px;
  background-color: transparent;
  margin-right: 10px !important;
  padding: 0 0 0 1px !important;
  min-width: 0 !important;
}
.container-separated {
  margin-top: 5px;
  margin-bottom: 6px;
}
.container-separated div {
  display: inline-block;
}
.container-separated div:nth-child(1) {
  margin-right: 5px;
}
.icon-separated-left,
.icon-separated-right {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 60px;
  background-color: #536a6e;
  border-radius: 5px;
  cursor: pointer;
}
.icon-separated-left {
  margin-left: 25px;
}
.icon-separated-right {
  margin-left: -18px;
}
.icon-separated-left-sub,
.icon-separated-right-sub {
  position: absolute;
  display: inline-block;
  width: 20px;
  height: 60px;
  background-color: white;
  border-radius: 5px;
}
.icon-separated-left-sub {
  left: -22px;
}
.icon-separated-right-sub {
  right: -27px;
}
/* button css img */
.btn-display {
  display: inline-block;
  position: relative;
  width: 45px;
  height: 45px;
  background-color: #536a6e;
  border-radius: 5px;
}
.btn.overlap .btn-display {
  width: 40px;
  height: 40px;
  margin-left: 5px;
  margin-bottom: 5px;
}
.btn.column .btn-display {
  width: 25px;
  height: 45px;
  margin-left: 20px;
}
.btn-faceVideo {
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 5px;
  bottom: 5px;
  left: 5px;
}
.btn.overlap .btn-faceVideo {
  bottom: -5px;
  left: -5px;
}
.btn.column .btn-faceVideo {
  bottom: 0px;
  width: 18px;
  height: 45px;
  left: -20px;
}
.btn.small .btn-faceVideo {
  width: 10px;
  height: 10px;
  border-radius: 3px;
}
.btn.large .btn-faceVideo {
  width: 30px;
  height: 30px;
}
.btn.round .btn-faceVideo {
  border-radius: 50%;
}
/* color picker */
.v-tab {
  text-transform: none !important;
  letter-spacing: 0 !important;
}
.v-menu__content {
  top: 20px !important;
  left: auto !important;
  right: 270px !important;
  border-radius: 20px;
}
.container-swatches >>> .v-color-picker__canvas {
  margin-top: 20px;
  border-radius: 5px;
}
.container-swatches {
  position: relative;
  min-width: 250px;
  background-color: #21343b;
}
.container-swatches >>> input {
  font-size: small;
  background-color: #eee;
  cursor: text;
}
.container-swatches >>> span {
  color: #aaa !important;
}
.container-swatches >>> .v-color-picker__color {
  width: 40px;
  max-height: 40px;
  height: 40px;
  border-radius: 50px;
}
.container-gradient {
  position: relative;
  background-color: #21343b;
}
.container-gradient >>> .v-btn span {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0;
}
.container-gradient p {
  font-size: 13px;
  color: #bbb;
  font-weight: 600;
  margin: 15px;
}
.container-gradient p:nth-child(2) {
  margin: 0 0 0 15px;
}
#layoutController >>> .container .btn.btn-pallette {
  background-color: #536a6e;
}
#layoutController >>> .container .btn.btn-pallette.v-btn--disabled {
  opacity: 0.3 !important;
}
/* side bar menu button */
.menu-controller {
  position: absolute;
  top: calc(50% - 40px);
  left: -50px;
  width: 50px;
  height: 80px;
  background-color: #21343b;
  border-radius: 10px 0 0 10px;
  cursor: pointer;
}
.icon-controller {
  position: relative;
  top: calc(50% - 12.5px);
  left: calc(50% - 13px);
  width: 30px;
  height: 25px;
  background-color: white;
  border-radius: 5px;
}
.icon-controller-sub {
  position: relative;
  top: 12px;
  left: -3px;
  width: 15px;
  height: 15px;
  background-color: #21343b;
  border: 2px solid white;
  border-radius: 5px;
}
</style>
